export default "__VITE_ASSET__Dl1nsAQz__"